import React, { useRef, useEffect, useState } from 'react'
import useOnScreen from '../hooks/useOnScreen';

const ParallaxImage = ({
	className,
	src,
	srcSet,
	alt,
	imageScale = 1.3
}) => {

	const containerEl = useRef(null)
	const containerElIsOnScreen = useOnScreen(containerEl)
	const imageEl = useRef(null)
	const imageElIsOnScreen = useOnScreen(imageEl)
	const [isImageLoaded, setIsImageLoaded] = useState(false)


	// Check if image is loaded
	useEffect(() => {
		if (isImageLoaded === true) return;
		if (imageEl.current.complete && imageEl.current.naturalHeight !== 0) {
			setIsImageLoaded(true)
		}
		imageEl.current.addEventListener('load', handleImageLoaded)
		const handleImageLoaded = () => {
			setIsImageLoaded(true)
			imageEl.current.removeEventListener('load', handleImageLoaded)
		}
		return () => {
			if (!imageEl.current) return
			imageEl.current.removeEventListener('load', handleImageLoaded)
		}
	}, [containerElIsOnScreen, isImageLoaded])

	// TO DO: have only one global scroll event for performances?
	useEffect(() => {
		if (localStorage.getItem('is-touch') === 'true') return

		let wh = 0
		let baseDistance = 0
		let distanceToTranslate = 0
		let newY = 0

		const handleResize = () => {
			wh = window.innerHeight
			const containerHeight = containerEl.current.getBoundingClientRect().height
			const imageHeight = imageEl.current.getBoundingClientRect().height
			distanceToTranslate = imageHeight - containerHeight
			baseDistance = wh + (containerHeight * 2)
		}

		const handleScroll = e => {
			const containerBottom = containerEl.current.getBoundingClientRect().bottom
			newY = (containerBottom / baseDistance) * distanceToTranslate
			requestAnimationFrame(loop)
		}

		const loop = () => {
			imageEl.current.style.transform = `scale(${imageScale}) translate3d(0, ${-newY}px, 0)`
		}

		const reset = () => {
			window.removeEventListener('scroll', handleScroll)
			window.removeEventListener('resize', handleResize)
		}

		if (containerElIsOnScreen === true && isImageLoaded === true) {
			window.addEventListener('scroll', handleScroll)
			window.addEventListener('resize', handleResize)
			loop()
			handleResize()
		} else {
			reset()
		}

		handleResize()
		handleScroll()

		return () => {
			reset()
		}
	}, [containerElIsOnScreen, isImageLoaded])

	return (
		<div
			className={`ParallaxImage ${className}`}
			data-is-on-screen
		>
			<div className="ParallaxImage__Container">
					<div
						className="ParallaxImage__Wrapper"
						ref={containerEl}
					>
						<img
							className={`ParallaxImage__Image ${imageElIsOnScreen ? 'onScreen' : ''}`}
							src={src}
							srcSet={srcSet}
							alt={alt}
							ref={imageEl}
						/>
				</div>
			</div>
		</div>
	)
}

export default ParallaxImage